import request from '@/utils/axios'

let base = '/backend/auth'

/**
 * 注册验证码
 * @param registerData
 */
export const register = registerData => {
  const formData = new FormData()
  formData.append('rd', window.btoa(JSON.stringify(registerData)))
  return request({
    url: `${base}/drag/captcha/register`,
    headers: {'Content-Type': 'multipart/form-data'},
    method: 'post',
    data: formData
  })
}

/**
 * 检查用户滑动数据
 * @param checkData
 */
export const check = checkData => {
  const formData = new FormData()
  formData.append('cd', window.btoa(JSON.stringify(checkData)))
  return request({
    url: `${base}/drag/captcha/check`,
    headers: {'Content-Type': 'multipart/form-data'},
    method: 'post',
    data: formData
  })
}

/**
 * 用户登录
 * @param loginData
 */
export const dragCaptchaLogin = loginData => {
  const formData = new FormData()
  formData.append('ld', window.btoa(JSON.stringify(loginData)))
  return request({
    url: `${base}/drag/captcha/login`,
    headers: {
      'Authorization': 'Basic Y2xvdWRhcHA6MTIzNDU2',
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}



// WEBPACK FOOTER //
// ./src/api/system/auth/dragCaptcha.js